<template>
	<aside
		class="property"
		:class="{ 'shrink': !isVisible }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<div class="property-title">
				{{ $t('Virtual Cam Properties ') }} - {{ label ? label.toUpperCase() : 'Default Virtual Cam Properties' }}
			</div>
			<button
				class="btn btn-default btn-sm btn-icon property-toggle"
				@click="isVisible = !isVisible">
				<i class="material-icons" v-if="isVisible">chevron_left</i>
				<i class="material-icons" v-else>chevron_right</i>
			</button>
		</div>
			<div class="property-content" :class="{'pointer-events-none': isLocked || isActiveEdit  ? isLocked.is_locked || isActiveEdit : true}">
				<!-- label and mute -->
				<div>
					<label class="text-primary">{{ $t('Virtual Cam Label') }} </label>
					<custom-input
						class="mb-3"
						align="left"
						:label="$t('Item Label')"
						:required="isRequired"
						@input="onKeywordChange"
						@keyenter="save"
						:max="40"
						v-model="label"
					/>
				</div>
				<div class="row mb-0 d-flex justify-content-between">
					<!-- solo audio -->
					<md-switch
						class="md-primary mt-0 ml-8px pl-2 "
						@change="openSoloVideo"
						v-model="isSoloVideo">
						{{ $t('Solo Video') }}
					</md-switch>

					<!-- mute audio -->
					<md-switch
						class="md-primary mt-0 mb-3"
						@change="openMutedAudio"
						v-model="virtualCamMute">
						{{ $t('Mute Audio') }}
					</md-switch>

				</div>
					<!-- layer -->
					<div class="form-group ml-0 pl-0 col-md-6">
						<custom-input
							type="number"
							class="form-control mb-3"
							field="index"
							:label="$t('Layer')"
							:required="isRequired"
							:max="100"
							:index-duplicated="isIndexDuplicated"
							@input="onKeywordChange"
							@keyenter="save"
							v-model="layerIndex"
						/>
					</div>
				<!-- input list -->
				<div>
					<div class="d-flex justify-content-between">
						<div><label class="text-primary">{{ $t('Virtual Cam Label') }} </label></div>
						<div>
							<button type="button"
								@click="openVirtualCam()"
								class="btn btn-blue btn-icon p-0 mw-34 mr-0">+
							</button>
						</div>
					</div>
					<!-- list virtual cam -->
					<div v-if="contentVirtualCams.length === 0" class="text-secondary mt-2">{{ $t('No input list added')}}</div>
					<div class="mt-2">
						<draggable
							v-model="filteredVirtualCams"
							v-bind="dragOptions"
							@start="drag = true"
							@end="drag = false"
							@change ="save">
								<transition-group
									type="transition"
									:name="!drag ? 'flip-list' : null">
									<div v-for="(contentVirtualCam, index) in filteredVirtualCams"
										:key="contentVirtualCam.url"
										class="flex-center w-100 relative virtual-cam-item-row-hover mt-1"
										@mouseover="itemHover(contentVirtualCam)" @mouseleave="itemLeave(contentVirtualCam)" :style="{ backgroundColor: (data.is_play_live && index+1 <= vcamLength) && !isSoloVideo? '#3bd14a80':'' }">
										<div class="d-flex" key="heading" >
											<div class="mt-1 truncate-virtual-name" :class="{'mt-5px': hover && hoverItem === contentVirtualCam.url}">
													{{contentVirtualCam.heading}}
											</div>
											<div class="d-flex" v-if="hover && hoverItem === contentVirtualCam.url">
												<button type="button"
													:disabled="isSoloVideo && index > 0"
													@click="togglePower(contentVirtualCam)"
													:class="{ 'btn-green':contentVirtualCam.is_power,'btn-danger':!contentVirtualCam.is_power  }"
													class="btn btn-icon p-0 mw-34 mr-1">
													<i class="material-icons icon-power">power_settings_new</i>
												</button>
												<button type="button"
													:disabled="virtualCamMute || (isSoloVideo && index > 0)"
													@click="toggleMute(contentVirtualCam)"
													class="btn btn-default btn-icon p-0 mw-34 mr-1">
													<i class="material-icons" v-if="!contentVirtualCam.is_mute && !virtualCamMute && (index == 0) ">volume_up</i>
													<i class="material-icons" v-if="!contentVirtualCam.is_mute && !virtualCamMute && (!isSoloVideo && index > 0) ">volume_up</i>
													<i class="material-icons" v-if="contentVirtualCam.is_mute || virtualCamMute || isSoloVideo && index > 0">volume_off</i>
												</button>
												<button type="button"
													:disabled="isSoloVideo && index > 0"
													@click="toggleHide(contentVirtualCam)"
													class="btn btn-default btn-icon p-0 mw-34 mr-1">
													<i class="material-icons" v-if="!contentVirtualCam.is_empty_feed && !contentVirtualCam.is_hide_label && (index == 0) ">visibility</i>
													<i class="material-icons" v-if="!contentVirtualCam.is_empty_feed && !contentVirtualCam.is_hide_label && (!isSoloVideo && index > 0) ">visibility</i>
													<i class="material-icons" v-if="contentVirtualCam.is_hide_label || contentVirtualCam.is_empty_feed || isSoloVideo && index > 0">visibility_off</i>
												</button>
												<button type="button"
													@click="editVirtualCam(contentVirtualCam)"
													class="btn btn-default btn-icon p-0 mw-34 mr-1">
													<i class="material-icons">edit</i>
												</button>
												<button type="button"
													@click="openDeleteModal(contentVirtualCam)"
													class="btn btn-danger btn-icon p-0 mw-34 mr-1">
													<i class="material-icons">delete</i>
												</button>
											</div>
										</div>
									</div>
								</transition-group>
						</draggable>
					</div>
					<!-- Layouts input -->
					<label class="text-primary mt-4 mr-1">{{ $t('Layout') }} </label><label v-if="layout" class="text-primary">- {{ layout }} </label>
					<div class="d-flex flex-row" :class="{'upload-wrapper': templateFile || template }">
						<div class="mt-4 mr-4 pointer" @click="playPreview()" v-if="template && !template.img_path"><i class="material-icons">camera_alt</i></div>
						<!-- <div class="mt-4 mr-4 pointer" v-if="template && template.img_path"> -->
						<img class="mr-2 mt-3 template-long-thumbnail pointer"
							@click="playPreview()"
							v-if="template && template.img_path"
							:src="template.img_path"
							height="30"
							width="53.33" />
						<template v-if="!isUploading && !templateFile && !template">
							<div :class="{'template-center': !templateFile && !template}" @click="openTemplate">
								<i class="material-icons icon-layout-virtual-cam">keyboard_arrow_right</i>
								<custom-input
									class="mb-3"
									align="left"
									:required="isRequired"
									v-model="layout"
									@click="openLayoutModal"
								/>
							</div>
						</template>
						<div v-if="isUploading">
								{{ $t('Uploading') }} {{ mediaProgress }}%
						</div>

						<div class="text-left text-break file-name-media w-75 pointer" @click="playPreview()" v-if="templateFile && !isUploading">
							{{ templateFile.name }}
						</div>

						<div class="text-left text-break file-name-media w-75 pointer" @click="playPreview()"
							v-if="!templateFile && !isUploading && template">
							{{ template.name }}
						</div>

						<div class="vertical-line ml-4 mr-4" v-if="templateFile || template"></div>
						<div class="d-flex flex-column">
							<div class="mt-4 pointer" @click="openTemplate" v-if="templateFile || template"><i class="material-icons">folder</i></div>
						</div>
					</div>
					<!-- backgrounds -->
					<div class="d-flex justify-content-between">
						<label class="text-primary mt-3 mr-1">{{ $t('Backgrounds') }} </label>
						<label v-if="contentMediaUrl" class="text-small text-grey mt-3 mr-1 pointer" @click="isConfirmRemoveBgVisible = true">{{ $t('Remove') }} </label>
					</div>
					<div class="form-group mb-1">
						<div class="d-flex flex-row"
							:class="{ 'upload-wrapper-error': !mediaUrl && !mediaFile && !media && isRequired,
							'upload-wrapper': mediaUrl || mediaFile || media || !isRequired }">
							<div class="mt-3 mr-2 pointer" v-if="mediaUrl || mediaFile || media">
								<i class="material-icons mt-1" v-if="mediaUrl==='' & mediaType === 'image'">camera_alt</i>
								<i class="material-icons mt-1"  v-if="mediaUrl==='' & mediaType === 'video'">local_movies</i>
								<img class="mr-2  media-property-thumbnail"
								v-if="mediaUrl && mediaType ==='image'"
								:src="mediaThumbnail ? mediaThumbnail : mediaUrl"
								height="30"
								width="53.33" />
								<img class="mr-2  media-property-thumbnail"
								v-if="mediaUrl &&  mediaType === 'video' "
								:src="mediaThumbnail"
								height="30"
								width="53.33" />
							</div>
							<template v-if="!isUploadingMedia && !mediaFile && !media && !mediaUrl" >
								<div class="text-left text-break w-75 mt-0 pointer"
									:class="{'template-center': !mediaFile && !media}">
									<label class="text-underline cur-p text-white">
										<span>Upload</span>
										<input type="file" id="mediaInputLt" accept=".png,.gif,.jpeg,.jpg"  class="hidden" @change="onMediaSelected">
									</label>
									<span> Image or Video File or Select from </span>
									<span class="text-underline cur-p" @click="openGallery">Gallery</span>
								</div>
							</template>
							<div class="text-left text-break w-75 uploading-text pointer" v-if="isUploadingMedia">
									{{ $t('Uploading') }} {{ progress }}%
							</div>
							<div class="text-left file-name-media pointer" v-if="mediaUrl !== media && mediaUrl && !isUploadingMedia">
								<div class="truncate">
									{{ media && media.name ? media.name : mediaLabel }}
								</div>
							</div>
							<div class="vertical-line ml-4 mr-4" v-if="mediaFile || media || mediaUrl"></div>
								<div class="d-flex flex-column">
									<div class="pointer" @click="openGallery" v-if="mediaFile || media || mediaUrl"><i class="material-icons">folder</i></div>
									<div class="pointer icon-upload-media mb-3"  v-if="mediaFile || media || mediaUrl">
									<label class="text-underline cur-p text-white pt-3 pb-0 mb-0">
									<span class="material-icons">file_upload</span>
									<input type="file" accept=".png,.gif,.jpeg,.jpg"  class="hidden" id="mediaInputLt" @change="onMediaSelected">
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- virtual cam -->
			<modal-virtual-cam
				:virtualCams="virtualCams"
				:virtualCam="selectedVirtualCam"
				@addVirtualCam="onVirtualCamAdded"
				@updateVirtualCam="onVirtualCamUpdate"
				@close="isModalVirtualCamVisible = false"
				v-if="isModalVirtualCamVisible"
			/>
			<!-- Delete Confirmation -->
			<modal
				size="small"
				class="template-modal gallery-modal-delete"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					A<span class="lowercase pr-1">{{ $t('re you sure want to delete') }}</span><span class="capitalize">{{virtualItemName}}?</span>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button class="btn btn-primary" :class="{ 'is-loading': isDeleting }" @click="removeVirtualCam">
							{{ $t('Yes, Delete It') }}
						</button>
						<button class="btn btn-default" @click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- Delete bg Confirmation -->
			<modal
				size="small"
				class="template-modal gallery-modal-delete"
				@close="isConfirmRemoveBgVisible = false"
				v-if="isConfirmRemoveBgVisible">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					A<span class="lowercase pr-1">{{ $t('re you sure want to remove the background?') }}</span>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button class="btn btn-primary" :class="{ 'is-loading': isDeletingBg }" @click="removeBackground">
							{{ $t('Yes, Remove It') }}
						</button>
						<button class="btn btn-default" @click="isConfirmRemoveBgVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
	</aside>
</template>

<script>
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
import {
	getAxiosErrorMessage,
	delay,
	duplicateVar,
} from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import CustomInput from '@/components/CustomInput.vue';
import fileApi from '@/api/file';
import mediasApi from '@/api/medias';
import Modal from '@/components/Modal.vue';
import ModalVirtualCam from '@/components/ModalVirtualCam.vue';

export default {
	name: 'VirtualCamProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		media: {
			type: Object,
		},
		template: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		CustomInput,
		Modal,
		ModalVirtualCam,
		draggable,
	},
	data() {
		return {
			isLoading: false,
			label: '',
			layerIndex: 0,
			isVisible: true,
			isRequired: false,
			isSaving: false,
			isActiveEdit: false,
			virtualCamMute: false,
			virtualCams: [],
			layoutInput: null,
			layout: 'Default',
			isLayoutModalVisible: false,
			// layout (template)
			templateFile: '',
			templates: [],
			isUploading: false,
			// backgrounds
			mediaFile: '',
			mediaUrl: '',
			mediaThumbnail: '',
			mediaLabel: '',
			mediaLoop: false,
			mediaType: 'image',
			mediaProgress: 0,
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			fileSize: '',
			isUploadingMedia: false,
			progress: 0,
			hover: false,
			hoverItem: null,
			isConfirmRemoveVisible: false,
			virtualItemName: '',
			isDeleting: false,
			selectedVirtualCam: null,
			isModalVirtualCamVisible: false,
			dragOptions: {
				animation: 100,
			},
			drag: false,
			isSoloVideo: false,
			// remove bg
			isConfirmRemoveBgVisible: false,
			isDeletingBg: false,
		};
	},
	methods: {
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		openSoloVideo() {
			this.save();
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.toggleSoloVideo(this.rundown.slug, this.isSoloVideo, callback, errorCallback);
		},
		openMutedAudio() {
			this.save();
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.muteAllVCam(this.rundown.slug, this.virtualCamMute, callback, errorCallback);
		},
		initData() {
			this.isVisible = true;
			this.reset();
			if (this.data) {
				let content = this.data.content;
				this.label = this.data.name;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				}
				if (content.template) {
					this.selectedTemplate = content.template;
					this.$emit('setTemplate', this.selectedTemplate);
				}
				if (content.virtualCams) {
					this.virtualCams = content.virtualCams;
				}
				if (content) {
					this.layerIndex = this.data.layer_index;
					this.mediaUrl = content.mediaUrl;
					this.mediaType = content.mediaType;
					this.mediaLabel = content.mediaLabel;
					this.virtualCamMute = content.isMutedAll;
					this.isSoloVideo = content.isSoloVideo;
				}
			}
		},
		onVirtualCamAdded(virtualCam) {
			this.virtualCams.push(virtualCam);
			this.save();
			this.isModalVirtualCamVisible = false;
		},
		onVirtualCamUpdate(virtualCams) {
			this.virtualCams = virtualCams;
			this.save();
			this.isModalVirtualCamVisible = false;
		},
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.url;
		},
		openDeleteModal(item) {
			this.selectedVirtualCam = item;
			this.virtualItemName = item.heading;
			this.isConfirmRemoveVisible = true;
		},
		reorder(vCamItems) {
			const items = [];
			for (let index = 0; index < vCamItems.length; index++) {
				items.push(vCamItems[index]);
				items[index].order = index + 1;
			}
			return items;
		},
		removeVirtualCam() {
			this.isDeleting = true;
			const virtualCams = this.contentVirtualCams;
			const index = virtualCams.findIndex(({ id }) => id === this.selectedVirtualCam.id);
			if (index !== -1) {
				virtualCams.splice(index, 1);
				this.isDeleting = false;
			}
			const callback = () => {
				this.virtualCams = this.reorder(virtualCams);
				this.save();
				this.isConfirmRemoveVisible = false;
			};
			const errorCallback = (e) => {
				const messageFromCallback = getAxiosErrorMessage(e);
				const message = messageFromCallback && messageFromCallback !== '' ? messageFromCallback : 'Error when uploading file';
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Virtual Cam',
					text: message,
					duration: 999999999,
				});
				this.isConfirmRemoveVisible = false;
			};
			rundownItemsApi.removeVCam(this.rundown.slug, this.selectedVirtualCam.id, callback, errorCallback);
		},
		openVirtualCam() {
			this.selectedVirtualCam = null;
			this.isModalVirtualCamVisible = true;
		},
		editVirtualCam(item) {
			this.selectedVirtualCam = duplicateVar(item);
			this.isModalVirtualCamVisible = true;
		},
		toggleHide(vcamItem) {
			// eslint-disable-next-line no-param-reassign
			vcamItem.is_empty_feed = !vcamItem.is_empty_feed;
			if (vcamItem.is_empty_feed) {
				// eslint-disable-next-line no-param-reassign
				vcamItem.is_hide_label = 1;
			} else {
				// eslint-disable-next-line no-param-reassign
				vcamItem.is_hide_label = 0;
			}
			this.isSaving = true;
			const callback = (response) => {
				const callback = () => {
				};
				const errorCallback = () => {
				};
				rundownItemsApi.hideVCam(this.rundown.slug, vcamItem.id, callback, errorCallback);
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			rundownItemsApi.update(this.data.id, this.virtualCamParams, callback, errorCallback);
		},
		toggleMute(vcamItem) {
			this.isSaving = true;
			// eslint-disable-next-line no-param-reassign
			vcamItem.is_mute = !vcamItem.is_mute;
			const callback = (response) => {
				// console.log(vcamItem);
				const callback = () => {
				};
				const errorCallback = () => {
				};
				const status = vcamItem.is_mute || (vcamItem.is_hide_label && vcamItem.is_empty_feed);
				// console.log(status);
				rundownItemsApi.muteVCam(this.rundown.slug, vcamItem.id, status, callback, errorCallback);
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			rundownItemsApi.update(this.data.id, this.virtualCamParams, callback, errorCallback);
		},
		togglePower(vcamItem) {
			this.isSaving = true;
			if (vcamItem.is_power && vcamItem.is_power === undefined) {
				// eslint-disable-next-line no-param-reassign
				vcamItem.is_power = true;
			} else {
				// eslint-disable-next-line no-param-reassign
				vcamItem.is_power = !vcamItem.is_power;
			}
			const callback = (response) => {
				const status = vcamItem.is_power ? 'on' : 'off';
				// this.save();
				const callbackToggle = () => {
				};
				const errorCallbackToggle = () => {
				};
				rundownItemsApi.toggleOffVCam(this.rundown.slug, vcamItem.id, status, this.data.id, callbackToggle, errorCallbackToggle);
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			rundownItemsApi.update(this.data.id, this.virtualCamParams, callback, errorCallback);
		},
		openTemplate() {
			this.$emit('browse');
		},
		openGallery() {
			this.$emit('browseMedia');
		},
		uploadMedia(file) {
			const params = new FormData();
			params.append('file', file);
			if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
			const callback = (response) => {
				const mediaUrl = response.data;
				this.mediaUrl = mediaUrl;
				this.isUploadingMedia = false;
				this.mediaProgress = 0;
				this.addMedia();
				this.save();
				if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
			};
			const errorCallback = (e) => {
				const messageFromCallback = getAxiosErrorMessage(e);
				const message = messageFromCallback && messageFromCallback !== '' ? messageFromCallback : 'Error when uploading file';
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Upload Media',
					text: message,
					duration: 999999999,
				});
				this.isUploadingMedia = false;
				this.mediaLabel = '';
				this.mediaFile = '';
				this.mediaUrl = '';
				this.mediaThumbnail = '';
			};
			const progressCallback = (progress) => {
				this.mediaProgress = progress;
			};
			fileApi.upload(params, callback, errorCallback, progressCallback);
		},
		addMedia() {
			const params = {
				name: this.mediaLabel,
				path: this.mediaUrl,
				type: 'image',
				thumbnail: this.mediaThumbnail,
				rundown_id: this.rundown.id || null,
				category_id: 1,
				size: this.fileSize,
			};
			const callback = () => {
			};
			const errorCallback = () => {
			};
			mediasApi.create(params, callback, errorCallback);
		},
		onMediaSelected(e) {
			this.initDataUser();
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // onegb
			}
			// upload
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
							if (this.rundownStorage) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									files = null;
									this.isCached = false;
									this.isCaching = false;
									if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
									return;
								}
								// eslint-disable-next-line no-else-return
							}
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Media',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							this.isUploadingMedia = true;
							// Read image for preview
							const reader = new FileReader();
							reader.onload = (theFile) => {
								this.fileSize = file.size / oneMB;
								this.mediaFile = file;
								// Remove extension from filename to set label
								let filename = duplicateVar(file.name);
								filename = filename.split('.').slice(0, -1).join('.');
								this.mediaLabel = duplicateVar(filename);
								const fileType = 'image';
								this.mediaType = fileType;
								if (fileType === 'image') {
									const image = new Image();
									image.src = theFile.target.result;
									image.onload = () => {
										this.uploadMedia(file);
									};
								}
							};
							reader.readAsDataURL(file);
						} else {
							files = null;
							if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						if (document.querySelector('#mediaInputLt')) document.querySelector('#mediaInputLt').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		reset() {
			this.label = '';
			this.selectedTemplate = null;
			this.label = '';
			this.layerIndex = 0;
			this.layoutInput = null;
			this.layout = 'Default';
			this.mediaFile = '';
			this.mediaUrl = '';
			this.mediaThumbnail = '';
			this.mediaLabel = '';
			this.mediaLoop = false;
			this.mediaType = 'image';
			this.mediaProgress = 0;
			this.settings = null;
			this.progress = 0;
			if (this.template) {
				this.selectedTemplate = this.template;
			}
		},
		onKeywordChange() {
			delay(() => {
				this.save();
			}, 1200);
		},
		save() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
				this.isDeletingBg = false;
				this.isConfirmRemoveBgVisible = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			rundownItemsApi.update(this.data.id, this.virtualCamParams, callback, errorCallback);
		},
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.layerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		openLayoutModal() {
			this.isLayoutModalVisible = true;
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048; // onegb
				}
			}
		},
		removeBackground() {
			this.isDeletingBg = true;
			this.mediaUrl = '';
			this.save();
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		currentTemplate() {
			const content = this.data && this.data.content ? this.data.content : '{}';
			const parsedContent = JSON.parse(content);
			const currentTemplate = parsedContent && parsedContent.template ? parsedContent.template : null;
			return currentTemplate;
		},
		vcamLength() {
			const templateContent = this.currentTemplate && this.currentTemplate.content ? this.currentTemplate.content : '{}';
			const parsedContent = templateContent ? JSON.parse(templateContent) : '{}';
			const vcamLength = parsedContent && parsedContent.vcam_count ? parsedContent.vcam_count : 2;
			return vcamLength;
		},
		virtualCamParams() {
			const content = {
				virtualCams: this.virtualCams,
				template: this.selectedTemplate,
				label: this.label,
				mediaUrl: this.mediaUrl,
				mediaType: this.mediaType,
				mediaLabel: this.mediaLabel,
				isSoloVideo: this.isSoloVideo,
				isMutedAll: this.virtualCamMute,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: this.label,
				type: this.type,
				content: contentString,
				layer_index: this.layerIndex,
				rundown_id: this.rundownId,
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.layerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		filteredVirtualCams: {
			get() {
				return this.virtualCams;
			},
			set(values) {
				this.virtualCams = this.reorder(values);
				this.save();
			},
		},
		contentVirtualCams() {
			let content = this.data.content;
			content = JSON.parse(content);
			const virtualCams = content && content.virtualCams ? content.virtualCams : '';
			return virtualCams;
		},
		contentMediaUrl() {
			let content = this.data.content;
			content = JSON.parse(content);
			const media = content && content.mediaUrl ? content.mediaUrl : '';
			return media;
		},
	},
	watch: {
		template() {
			if (this.template) {
				if (this.selectedTemplate !== this.template) {
					this.selectedTemplate = this.template;
					this.onKeywordChange();
				}
			}
		},
		media() {
			if (this.media) {
				this.mediaUrl = this.media.path;
				this.mediaLabel = this.media.name;
				this.mediaType = this.media.type;
				// Update Media
				if (this.mediaType === 'image') {
					const image = new Image();
					image.src = this.mediaUrl;
					image.onload = () => {
						const originalWidth = image.width;
						const originalHeight = image.height;
						this.mediaWidth = originalWidth;
						this.mediaHeight = originalHeight;
						this.save();
					};
				}
			}
		},
		data() {
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				this.label = this.data.name;
				this.layerIndex = this.data.layer_index;
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				} else {
					this.isActiveEdit = false;
				}
				if (content.template) {
					this.selectedTemplate = content.template;
					this.$emit('setTemplate', this.selectedTemplate);
				}
				if (this.data) {
					let content = this.data.content;
					this.label = this.data.name;
					if (typeof content === 'string') {
						content = JSON.parse(content);
					}
					if (content && this.isActiveEdit) {
						this.layerIndex = this.data.layer_index;
						this.mediaUrl = content.mediaUrl;
						this.mediaType = content.mediaType;
						this.mediaLabel = content.mediaLabel;
						this.virtualCamMute = content.isMutedAll;
						this.isSoloVideo = content.isSoloVideo;
					}
				}
			}
		},
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		this.$nextTick(() => {
			this.initData();
		});
		this.isLoading = true;
		this.isRequired = false;
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 400);
	},
};
</script>
